import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private auth: AuthService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorMsg = '';
                    if (error.error instanceof ErrorEvent) {
                        console.log('this is client side error');
                        errorMsg = `Error: ${error.error.message}`;
                    }
                    else {
                        if (error.status === 401) {
                            console.log('Acesso negado', 'Sem permissão de acesso neste servidor');
                            this.logout();
                        } else if (error.status === 403) {
                            console.log('Erro 405', 'Método não autorizado');
                            this.logout();
                        } else if (error.status === 400) {
                            console.log('Erro 400', 'Bad request');
                        } else if (error.status === 404) {
                            console.log('Erro 404', 'Não encontrado');
                        } else if (error.status === 405 || error.status === 403) {
                            console.log('Erro 405', 'Método não autorizado');
                        } else if (error.status === 408) {
                            console.log('Erro 408', 'Tempo limite do pedido esgotado');
                        } else if (error.status === 414) {
                            console.log('Erro 414', 'URI de pedido demasiado longo');
                        } else if (error.status === 500) {
                            console.log('Erro interno do servidor', 'Contacte o administrador');
                        }
                    }
                    console.log(errorMsg);
                    return throwError(errorMsg);
                })
            )
    }

    private logout() {
        this.auth.logout();
        this.router.navigate(['/login'], { skipLocationChange: true });
    }

}
